import { useMemo } from "react";
import { Redirect, Route, Switch, useParams } from "react-router-dom";

import moment from "moment";

import { TitleHeader } from "../../components/TitleHeader";
import { TabBar } from "../../components/tabs/TabBar";
import { useOnboardingTasks } from "../../workflow/follow-up/appointment/TaskProvider";
import { TabBarItem } from "../../components/tabs/TabBarItem";
import { IntegratedApplicationTab } from "./IntegratedApplicationTab";

export const IntegratedOnboardingOverviewPage = () => {
    const { tab } = useParams<{ tab: "application" }>();

    const tabIndex = useMemo(() => {
        switch ( tab ) {
            case "application": return 0;

            default: return 0;
        }
    }, [tab]);

    const now = moment().toISOString(true);

    const onboardingTasks = useOnboardingTasks();
    const currentOnboardingTasks = useMemo(() => onboardingTasks.filter(task => task.performAfterDate <= now), [onboardingTasks, now]);

    if ( tab !== "application" ) return <Redirect to="/onboarding/application" />;

    return (
        <>
            <TitleHeader>Onboarding</TitleHeader>

            <TabBar index={tabIndex}>
                <TabBarItem href="/onboarding/application">{formatTitle("Ansøgning", currentOnboardingTasks.length)}</TabBarItem>
            </TabBar>

            <Switch>

                <Route exact path="/onboarding/application">
                    <IntegratedApplicationTab />
                </Route>

            </Switch>
        </>
    );
};

function formatTitle(text: string, count: number): string {
    if ( count === 0 ) return text;

    return `${text} (${count})`;
};
